export default {"src":"/_next/static/media/investorFriendly.8d9aefef.svg","height":54,"width":53};